import { render } from "./BaseInputTextarea.vue?vue&type=template&id=52c29704&scoped=true&ts=true&lang=pug"
import script from "./BaseInputTextarea.vue?vue&type=script&lang=ts"
export * from "./BaseInputTextarea.vue?vue&type=script&lang=ts"

import "./BaseInputTextarea.vue?vue&type=style&index=0&id=52c29704&lang=scss&scoped=true"

import exportComponent from "/tarball/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52c29704"]])

export default __exports__